import { render } from "./chevron-double-right.vue?vue&type=template&id=627133dc"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/chevron-double-right.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "627133dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('627133dc', __exports__)) {
    api.reload('627133dc', __exports__)
  }
  
  module.hot.accept("./chevron-double-right.vue?vue&type=template&id=627133dc", () => {
    api.rerender('627133dc', render)
  })

}


export default __exports__